export default __webpack_public_path__ + "static/media/sloth.fa195023.png";